import * as React from "react"
import { SVGProps } from "react"

const Pencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.902 2.856a2.25 2.25 0 0 1 3.182 0l1.06 1.06a2.25 2.25 0 0 1 0 3.182L7.35 14.893a.75.75 0 0 1-.383.205l-3.978.795a.75.75 0 0 1-.882-.882l.795-3.978a.75.75 0 0 1 .205-.383l7.795-7.794Zm2.121 1.06 1.06 1.061a.75.75 0 0 1 0 1.06l-1.06 1.061-2.121-2.12 1.06-1.062a.75.75 0 0 1 1.061 0ZM9.841 6.038 4.328 11.55l-.53 2.652 2.652-.53 5.512-5.513-2.121-2.121Z"
      fill="#9DA3B7"
    />
  </svg>
)

export default Pencil
